/* INA IRETI — Theme JS */
(function() {
  'use strict';

  // ---- Header scroll effect ----
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 40);
    }, { passive: true });
  }

  // ---- Mobile menu ----
  const mobileMenu = document.querySelector('.mobile-menu');
  const menuToggle = document.querySelector('.header__menu-toggle');
  const menuClose = document.querySelector('.mobile-menu__close');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      mobileMenu.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  }
  if (menuClose && mobileMenu) {
    menuClose.addEventListener('click', () => {
      mobileMenu.classList.remove('open');
      document.body.style.overflow = '';
    });
  }

  // ---- Cart Drawer ----
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartOverlay = document.querySelector('.cart-drawer-overlay');
  const cartTriggers = document.querySelectorAll('[data-cart-trigger]');
  const cartClose = document.querySelector('[data-cart-close]');

  function openCart() {
    if (cartDrawer) { cartDrawer.classList.add('open'); document.body.style.overflow = 'hidden'; }
    if (cartOverlay) { cartOverlay.classList.add('open'); }
  }
  function closeCart() {
    if (cartDrawer) { cartDrawer.classList.remove('open'); document.body.style.overflow = ''; }
    if (cartOverlay) { cartOverlay.classList.remove('open'); }
  }

  cartTriggers.forEach(t => t.addEventListener('click', (e) => { e.preventDefault(); openCart(); }));
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // ---- Add to Cart ----
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    btn.textContent = 'Ajout en cours...';

    try {
      const resp = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (resp.ok) {
        await updateCartCount();
        openCart();
        await refreshCartDrawer();
      }
    } catch(err) { console.error(err); }
    finally {
      btn.disabled = false;
      btn.textContent = btn.dataset.originalText || 'Ajouter au panier';
    }
  });

  async function updateCartCount() {
    try {
      const resp = await fetch('/cart.js');
      const cart = await resp.json();
      const counts = document.querySelectorAll('.header__cart-count');
      counts.forEach(el => { el.textContent = cart.item_count; });
    } catch(e) {}
  }

  async function refreshCartDrawer() {
    const items = document.querySelector('.cart-drawer__items');
    const subtotal = document.querySelector('.cart-drawer__subtotal strong');
    if (!items) return;
    try {
      const resp = await fetch('/cart.js');
      const cart = await resp.json();
      if (subtotal) {
        subtotal.textContent = formatMoney(cart.total_price);
      }
      items.innerHTML = cart.items.map(item => `
        <div class="drawer-item">
          <div class="drawer-item__img"><img src="${item.image}" alt="${item.title}" loading="lazy"></div>
          <div>
            <p class="drawer-item__name">${item.product_title}</p>
            <p class="drawer-item__price">${formatMoney(item.line_price)} — Qté: ${item.quantity}</p>
          </div>
        </div>
      `).join('');
    } catch(e) {}
  }

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  // ---- Product gallery thumbnails ----
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainImg = document.querySelector('.product-gallery__main img');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImg) {
        mainImg.src = thumb.querySelector('img').src;
        mainImg.srcset = thumb.querySelector('img').srcset || '';
      }
    });
  });

  // ---- Hero slider ----
  const heroDots = document.querySelectorAll('.hero__dot');
  const heroSlides = document.querySelectorAll('.hero__slide');
  if (heroDots.length > 1 && heroSlides.length > 1) {
    let current = 0;
    const goTo = (i) => {
      heroSlides[current].style.opacity = '0';
      heroDots[current].classList.remove('active');
      current = i;
      heroSlides[current].style.opacity = '1';
      heroDots[current].classList.add('active');
    };
    heroDots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i)));
    setInterval(() => goTo((current + 1) % heroSlides.length), 6000);
  }

  // ---- Quantity selectors ----
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty]');
    if (!btn) return;
    const input = btn.closest('.qty-wrap')?.querySelector('input[type=number]');
    if (!input) return;
    const dir = btn.dataset.qty;
    const val = parseInt(input.value) || 1;
    if (dir === '+') input.value = val + 1;
    if (dir === '-' && val > 1) input.value = val - 1;
  });

  // ---- Newsletter form ----
  const newsletterForm = document.querySelector('.newsletter__form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const input = newsletterForm.querySelector('input');
      const btn = newsletterForm.querySelector('button');
      if (input && btn) {
        btn.textContent = 'Merci !';
        input.value = '';
        setTimeout(() => { btn.textContent = "S'inscrire"; }, 3000);
      }
    });
  }

  // ---- Smooth reveal on scroll ----
  const reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    reveals.forEach(el => observer.observe(el));
  }

})();
